export const workflowPropertyNameRegex = /(.*?)\s*\(order property=(\d+)/;
